var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2213 3.37495L13.2208 3.37506C12.8127 3.48263 12.4705 3.76115 12.28 4.14041C11.5051 5.69176 10.9236 6.63844 10.3364 7.40841L10.3363 7.40846C9.74171 8.1873 9.11509 8.82326 8.16855 9.7682C6.00734 11.931 4.9252 14.7676 4.9252 17.5998C4.9252 20.432 6.00737 23.2686 8.16862 25.4315C12.4942 29.7554 19.5062 29.7554 23.8318 25.4315C25.993 23.2686 27.0752 20.432 27.0752 17.5998C27.0752 14.7676 25.993 11.931 23.8318 9.76816C23.4101 9.34642 22.7759 9.22095 22.2241 9.44965L22.2238 9.44975C21.6725 9.67676 21.314 10.215 21.314 10.811C21.314 12.603 21.2032 13.9939 20.6648 15.1117C20.3676 15.7292 19.9036 16.3322 19.1102 16.8682L18.9384 16.9842L18.9159 16.7782C18.7308 15.0854 18.3925 13.0215 17.9361 11.065L17.936 11.065C17.5769 9.52292 17.1307 7.98779 16.6 6.71015L16.5999 6.71005C16.3346 6.06982 16.0355 5.46581 15.6984 4.94442L15.6984 4.94438C15.3705 4.43673 14.9527 3.92911 14.4189 3.57267C14.0662 3.3381 13.6296 3.26586 13.2213 3.37495ZM16.9237 21.4742C18.1475 21.462 19.0935 21.2705 19.7373 21.0799C20.07 20.9815 20.3221 20.8833 20.49 20.8102C20.574 20.7736 20.637 20.7434 20.6786 20.7225C20.6993 20.712 20.7147 20.704 20.7247 20.6986L20.7356 20.6927L20.738 20.6913L20.7384 20.6911L20.7385 20.6911L20.7385 20.6911L20.9252 20.5849V20.7998C20.9252 22.0604 20.4442 23.3214 19.4821 24.2818C17.5597 26.2057 14.4407 26.2057 12.5183 24.2818C11.5562 23.3214 11.0752 22.0604 11.0752 20.7998C11.0752 19.5392 11.5562 18.2783 12.5182 17.3179C12.9869 16.8484 13.3294 16.5024 13.655 16.0756C13.98 15.6495 14.2905 15.1398 14.6884 14.3439L14.7517 14.2172L14.8695 14.2958C15.0393 14.409 15.1941 14.587 15.3356 14.8052C15.4777 15.0246 15.6107 15.2913 15.7344 15.5894C15.9818 16.1856 16.1961 16.9179 16.3719 17.6714C16.7059 19.1029 16.905 20.6289 16.9237 21.4742Z",
    fill: "url(#paint0_linear_14697_13196)",
    stroke: "#0A0103",
    strokeWidth: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14697_13196",
    x1: 34.4356,
    y1: 11.469,
    x2: 17.0985,
    y2: 34.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.82be1b427b36c082bbefbdb57f5c3bf6.svg";
export { ForwardRef as ReactComponent };